import axios from 'axios';
import {baseURL} from '../constants/API_CONSTANTS';

axios.defaults.baseURL = baseURL;
axios.defaults.headers.post['Content-Type'] = 'application/json';

const axiosAPI = axios.create();

export default axiosAPI;
